import React, { useState, useEffect, useRef } from 'react';
import { useSetRecoilState } from 'recoil';
import { overlayProppress } from '../../atoms/OverlayProgress';
import { flashMessageSuccess, flashMessageError } from '../../atoms/FlashMessage';
import { RouteComponentProps } from 'react-router-dom';
import * as _usr_const from '../../config/usr-constant';
import * as _form from '../../helper/form';
import * as _customersFormFunc from './func/CustomersForm'
import axios from 'axios';
import Paper from '@material-ui/core/Paper';
import Loading from '../../components/View/Loading';
import HeadButtonGroups, { HeadButtonGroupBtnActionsProps } from '../../components/View/HeadButtonGroups';
import AddessInputs from '../../components/Form/AddressInputs';
import AjaxSelect from '../../components/Form/AjaxSelect';
import ZshTextField from '../../components/Form/ZshTextField';

function CustomersEdit({ history, match }: RouteComponentProps<{ id: string }>) {

  const setOverlayProppress = useSetRecoilState(overlayProppress);
  const setFlashMessageSuccess = useSetRecoilState(flashMessageSuccess);
  const setFlashMessageError = useSetRecoilState(flashMessageError);

  const actionName = 'customers/edit/';
  const backActionName = '/customers';

  const unmounted = useRef(false);
  const source = useRef(axios.CancelToken.source());
  const dataSource = useRef(axios.CancelToken.source());

  const [isInit, setInit] = useState(true);
  const [dataMounted, setDataMounted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    customer_status_id: '',
    last_name: '',
    first_name: '',
    last_name_kana: '',
    first_name_kana: '',
    tel: '',
    email: '',
    zipcode_1: '',
    zipcode_2: '',
    prefecture: '',
    address_1: '',
    address_2: '',
  });
  const [validateErrors, setValidateErrors] = useState({});
  const [statuses, setStatuses] = useState({});
  const [statusesError, setStatusesError] = useState(false);

  const handleChange = (event: any) => {
    const inputName = event.target.name;
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
    setFormData({ ...formData, [inputName]: value });
  };

  const setValue = (name: any, value: any) => {
    _form.setValue({
      formData,
      name,
      value,
      setFormData
    });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    _form.handleSubmit({
      action: actionName + match.params.id,
      formData,
      history,
      backActionName,
      setOverlayProppress,
      setFlashMessageSuccess,
      setFlashMessageError,
      setValidateErrors
    });
  }

  // clean up
  useEffect(() => {
    const clSource = Object.assign({}, source.current);
    const clDSource = Object.assign({}, dataSource.current);
    return () => {
      // cancel axios get
      clSource.cancel('cancel customer form statuses get');
      clDSource.cancel('cancel customer form data get');
      unmounted.current = true;
    }
  }, []);

  useEffect(() => {
    if (isInit) {
      const initFunc = async () => {
        await _customersFormFunc.getStatuses({
          unmounted: unmounted.current,
          setStatuses,
          setStatusesError,
          source
        });
        if (dataMounted === false) {
          const tepFormData = Object.assign({}, formData);
          await axios
            .get(_usr_const.ApiUrl + actionName + match.params.id + '/index.json', {
              cancelToken: dataSource.current.token
            })
            .then((results: any) => {
              if (!unmounted.current) {
                let customer = results.data.customer;
                if (customer.customer_status_id === null) {
                  customer.customer_status_id = '';
                }
                const formData = _form.setFormData(tepFormData, customer);
                setDataMounted(true);
                setFormData(formData);
              }
            })
            .finally(() => {
              return Promise.resolve(1);
            });
        }
        await ((): any => {
          if (!unmounted.current) {
            setLoading(false);
          }
          return Promise.resolve(1);
        })();
      }
      initFunc();
      setInit(false);
    }
  }, [isInit, dataMounted, formData, match.params.id]);

  const btnActions: HeadButtonGroupBtnActionsProps[] = [
    {
      type: 'save',
    }
  ];

  return (
    <div className="content-1">
      <form onSubmit={handleSubmit}>
        <Loading loading={loading} />
        {
          dataMounted &&
          <div>
            <HeadButtonGroups
              history={history}
              btnActions={btnActions}
            />
            <Paper>
              <div className="view-content-in form-content">
                <table className="form-table">
                  <tbody>
                    <tr>
                      <th className="required-th">ステータス</th>
                      <td>
                        <div className="form-input-group">
                          <AjaxSelect
                            name="customer_status_id"
                            menuItems={statuses}
                            formData={formData}
                            handleChange={handleChange}
                            getError={statusesError}
                            validateErrors={validateErrors}
                            required
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="required-th">姓</th>
                      <td>
                        <div className="form-input-group">
                          <ZshTextField
                            value={formData.last_name}
                            name="last_name"
                            onChange={handleChange}
                            required
                            validateErrors={validateErrors}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="required-th">名</th>
                      <td>
                        <div className="form-input-group">
                          <ZshTextField
                            value={formData.first_name}
                            name="first_name"
                            onChange={handleChange}
                            required
                            validateErrors={validateErrors}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>姓 （カナ）</th>
                      <td>
                        <div className="form-input-group">
                          <ZshTextField
                            value={formData.last_name_kana}
                            name="last_name_kana"
                            onChange={handleChange}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>名 （カナ）</th>
                      <td>
                        <div className="form-input-group">
                          <ZshTextField
                            value={formData.first_name_kana}
                            name="first_name_kana"
                            onChange={handleChange}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>電話番号</th>
                      <td>
                        <div className="form-input-group">
                          <ZshTextField
                            value={formData.tel}
                            name="tel"
                            onChange={handleChange}
                            fullWidth
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>メールアドレス</th>
                      <td>
                        <div className="form-input-group">
                          <ZshTextField
                            value={formData.email}
                            name="email"
                            onChange={handleChange}
                            fullWidth
                            validateErrors={validateErrors}
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>住所</th>
                      <td>
                        <AddessInputs
                          formData={formData}
                          handleChange={handleChange}
                          setValue={setValue}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Paper>
            <HeadButtonGroups
              history={history}
              btnActions={btnActions}
            />
          </div>
        }
      </form>
    </div>
  )
}

export default CustomersEdit;